import { TranslateService } from '@ngx-translate/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { timeUnits } from '@models/consts/timeUnits.const';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { Log } from "ng2-logger";


@Component({
    selector: "app-input-duration",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputDurationComponent,
            multi: true
        }
    ],
    templateUrl: './input-duration.component.html',
    styleUrls: ['input-duration.component.scss']
})
export class InputDurationComponent implements ControlValueAccessor {
    _logger = Log.create(InputDurationComponent.name);

    @Input() label;
    @Input() labelAlign = 'top';
    @Input() placeholder;
    @Input() formControl: UntypedFormControl;
    @Input() showErrors = false;
    @Input() tooltipText = '';

    @Output() inputChange = new EventEmitter<any>();

    timeUnits = timeUnits;
    selectedUnit = 'minutes';
    multiplier = 1;

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    private _value = 0;

    constructor(private translateService: TranslateService) {
        this.translateTimeUnits();
    }

    @HostBinding('class.label-left')
    get leftAlignLabel() {
        return this.labelAlign === 'left';
    }

    writeValue(value) {
        this._value = value;
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }

    onTimeUnitChange(unit) {
        const changedValue = this.value / (unit.multiplier / this.multiplier);
        this.multiplier = unit.multiplier;
        this.value = Math.round(changedValue);
    }

    private translateTimeUnits() {
        this.translateService.stream("timeUnits").subscribe(units => {
            this.timeUnits = this.timeUnits.map(timeUnit => {
                timeUnit.label = units[timeUnit.code];
                return timeUnit;
            });
        });
    }

    resetTimeUnit() {
        this.selectedUnit = 'minutes';
        this.multiplier = 1;
        this.value = this._value;
    }

    get value() {
        return this._value;
    }

    set value(value: number) {
        this._value = value;
        this.onChangeCallback(value);
        this.inputChange.emit({
            value: value,
            multiplier: this.multiplier
        });
    }

    get hasError() {
        return this.formControl && this.formControl.errors && this.showErrors;
    }

}

